// **************************************************
// Get currently visible section and add class to its href in side menu
// **************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.addEventListener('scroll', () => {
    const sections = document.querySelectorAll('.scroll-module__item');
    const visibleSection = Array.from(sections).find((section) => injection.isVisible(section));

    if (visibleSection) {
      const id = visibleSection.getAttribute('id');
      const navLinks = document.querySelectorAll('.scroll-module__list-item');
      navLinks.forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
      });
    }
  });
});
